import React from 'react';
import { Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-12" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <div className="grid md:grid-cols-4 gap-8 mb-8 border-b border-slate-800 pb-8" data-id="element-95">
          <div className="md:col-span-2" data-id="element-96">
            <div className="mb-4" data-id="element-97">
              <div className="inline-flex bg-white rounded-lg p-3" data-id="element-98">
                <img src="https://cdn.magicpatterns.com/uploads/be5SqDSFguqgTJHkx6oq5s/mobile_the_neuropathy_healing_center_logo_1200px.png" alt="The Neuropathy & Healing Center" className="h-12 w-auto" data-id="element-99" />
              </div>
            </div>
            <p className="text-sm text-slate-400 max-w-sm mb-6" data-id="element-100">
              Dedicated to providing drug-free, non-surgical relief for
              peripheral neuropathy patients in St. Augustine and surrounding
              areas.
            </p>
            <div className="flex gap-4" data-id="element-101">
              <a href="https://www.facebook.com/neuropathyhealingctr/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-102">
                <Facebook className="w-5 h-5" data-id="element-103" />
              </a>
            </div>
          </div>

          <div data-id="element-104">
            <h4 className="text-white font-bold mb-4" data-id="element-105">Quick Links</h4>
            <ul className="flex flex-col gap-2 text-sm" data-id="element-106">
              <li data-id="element-107">
                <a href="#neuropathy" className="hover:text-white transition-colors" data-id="element-108">
                  Symptoms
                </a>
              </li>
              <li data-id="element-109">
                <a href="#treatments" className="hover:text-white transition-colors" data-id="element-110">
                  Treatments
                </a>
              </li>
              <li data-id="element-111">
                <a href="#results" className="hover:text-white transition-colors" data-id="element-112">
                  Results
                </a>
              </li>
              <li data-id="element-113">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-114">
                  About Us
                </a>
              </li>
              <li data-id="element-115">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-116">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-117">
            <h4 className="text-white font-bold mb-4" data-id="element-118">Contact</h4>
            <ul className="flex flex-col gap-2 text-sm" data-id="element-119">
              <li data-id="element-120">1 St. Johns Medical Park Dr, Ste 2</li>
              <li data-id="element-121">St. Augustine, FL 32086</li>
              <li data-id="element-122">
                <a href="tel:9041234567" className="hover:text-white transition-colors" data-id="element-123">
                  (904) 123-4567
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-xs text-slate-500 flex flex-col gap-4" data-id="element-124">
          <p data-id="element-125">
            *Disclaimer: The information on this website is for educational
            purposes only and is not intended as medical advice. Individual
            results may vary. Testimonials are from actual patients of our
            clinic. Our treatments are not intended to diagnose, treat, cure, or
            prevent any disease beyond the scope of our practice. Please consult
            with a qualified healthcare provider regarding your specific medical
            condition.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-4 border-t border-slate-800" data-id="element-126">
            <p data-id="element-127">
              &copy; {new Date().getFullYear()} The Neuropathy & Healing Center.
              All rights reserved.
            </p>
            <div className="flex gap-4" data-id="element-128">
              <a href="#" className="hover:text-white transition-colors" data-id="element-129">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-130">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}